/**
 * Скачивание вложения объекта: крупные файлы в S3/MinIO приходят как JSON с `url` (presigned).
 */
import { getToken } from "@/lib/api-client-v2";

/**
 * Скачать тело вложения; для presigned-ответа делает второй `fetch` на MinIO.
 */
export async function fetchObjectFileAsBlob(
  objectId: number,
  fileId: number,
  options?: { forceStream?: boolean }
): Promise<Blob> {
  const token = getToken();
  const q = options?.forceStream ? "?stream=1" : "";
  const res = await fetch(
    `/api/v1/objects/${objectId}/files/${fileId}/download${q}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
  if (!res.ok) throw new Error("Не удалось скачать файл");
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  if (ct.includes("application/json")) {
    const j = (await res.json()) as { url: string; filename: string; expires_in?: number };
    const r2 = await fetch(j.url, { method: "GET" });
    if (!r2.ok) throw new Error("Не удалось скачать по presigned URL");
    return r2.blob();
  }
  return res.blob();
}
